import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

/**
 * One-time StatusBar configuration that prevents overlay toggling corruption
 */
export async function configureStatusBar() {
  if (Capacitor.getPlatform() !== 'ios') return;
  
  try {
    // Set solid statusbar - no overlay toggling to prevent page corruption
    await StatusBar.setOverlaysWebView({ overlay: false });
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: '#0b0b0b' }); // Match #root background
    console.log('[StatusBar] Configured with stable overlay:false');
  } catch (error) {
    console.warn('[StatusBar] Configuration failed:', error);
  }
}